import {
  BoostTimerNotificationSubscription,
  BoostTimerNotificationSubscriptionDocument,
} from './BoostTimerNotificationSubscription.generated';
import addBoostNotificationToQueue from '../../../helpers/addBoostNotificationToQueue';

const onBoostTimerNotification: WorkerSubscription = (args) => {
  const { context, client, addToQueue } = args;
  if (!context.featureFlags.get('isCasinoBoostsEnabled')) {
    return;
  }
  client
    .request({
      query: BoostTimerNotificationSubscriptionDocument,
      variables: { input: {} },
    })
    .subscribe({
      error: console.error,
      next: (value) => {
        const data = value.data as Maybe<BoostTimerNotificationSubscription>;
        const notification =
          data?.casinoBoostsPublicBoostTimerUpdated?.boostTimer;
        if (notification?.isTimerOver) {
          addBoostNotificationToQueue(addToQueue, notification);
        }
      },
    });
};

export default onBoostTimerNotification;
